import Skeleton from 'react-loading-skeleton';

import './style.scss';

type EssentialFormSkeletonProps = {
  isDefaultLoading?: boolean;
};

export function EssentialFormSkeleton({ isDefaultLoading = false }: EssentialFormSkeletonProps) {
  if (isDefaultLoading) {
    return (
      <div className={`container-lg px-5 product-selector-container`}>
        <div className="d-flex flex-column gap-2">
          <Skeleton height={32} width={'40%'} />
          <Skeleton height={40} />
        </div>
      </div>
    );
  }

  return (
    <div className="container-xxl px-4 px-md-5">
      <div className="row g-3">
        <div className="col-12 col-lg-7">
          <div className="grid gap-2 essential-form pb-64px">
            <div className="g-col-12 g-col-md-6">
              <Skeleton height={40} />
            </div>
            <div className="g-col-12 g-col-md-6">
              <Skeleton height={40} />
            </div>
            <div className="g-col-12">
              <Skeleton height={100} />
            </div>
            <div className="g-col-12 g-col-md-6">
              <Skeleton height={100} />
            </div>
            <div className="g-col-12 g-col-md-6">
              <Skeleton height={100} />
            </div>
            <div className="g-col-12 g-col-md-6">
              <Skeleton height={100} />
            </div>
            <div className="g-col-12 g-col-md-6">
              <Skeleton height={100} />
            </div>
          </div>
        </div>
        <div className="col-12 col-lg-5">
          <Skeleton height="350px" className="w-100" />
        </div>
      </div>
    </div>
  );
}
